import Repository from "@/repository";

export default {
  namespaced: true,

  state: {
    carTypes: [],
    tires: [],
  },

  actions: {
    async fetchCarTypes({ commit }) {
      const { value, error } = await Repository.RecordParams.get();
      if (!error && value) {
        commit("setCarTypes", value);
      }
    },
    async fetchTires({ commit }, { slug }) {
      if (!slug) {
        return;
      }
      const { value, error } = await Repository.RecordParams.getTires(slug);
      if (!error && value) {
        commit("setTires", value);
      }
    },
  },

  mutations: {
    setCarTypes(state, value) {
      state.carTypes = value;
    },
    setTires(state, value) {
      state.tires = value;
    },
    resetRecordParams(state) {
      state.carTypes = [];
      state.tires = [];
    },
  },
};
